import BaseApi from "../api/BaseApi";
import {Button, List, RichCell, SimpleCell, SplitCol, SplitLayout} from "@vkontakte/vkui";
import React from "react";
import BaseComponent from "../components/BaseComponent";
import {Icon20EditCircleFillBlue} from "@vkontakte/icons";
import {MODAL_SELECT_LIST} from "../assets/constants";
import KBInput from "../assets/KBInput";
import SelectList from "../assets/SelectList";
import * as constants from "../assets/constants";
import StandCollectionsSelectList from "../references/standcollections/standcollectionsSelectList";


class SummaryListSalePoint extends BaseComponent {

    constructor(props) {
        super(props);

        this.state = {
            current_item: {},

            current_index: -1,
            ...this.state
        }

    }

    types = constants.getEquipmentTypes()
    renderRow = (item, index) => {

        console.log(item)
        const groups = []
        const groupIndex = {}
        let num_collections = 0
        if (item.collections && Object.keys(item.collections).length > 0) {
            num_collections = Object.keys(item.collections).length
            Object.keys(item.collections).forEach(id => {
                const c = item.collections[id]
                const key = c.kit_id ? `kit-${c.kit_id}` : 'none'
                if (groupIndex[key] === undefined) {
                    groupIndex[key] = groups.length
                    groups.push({
                        key,
                        title: c.kit_title || '',
                        items: [],
                    })
                }
                groups[groupIndex[key]].items.push({id, title: c.title})
            })
            groups.sort((a, b) => (a.key === 'none') - (b.key === 'none'))
        } else if (item.qnt) {
            num_collections = item.qnt
        }

        return <RichCell onClick={() => {

            this.setState({current_item: item, current_index: index});

            if (item.is_competitor) return
            this.setActiveModal(MODAL_SELECT_LIST)
        }}
                         afterCaption={<div style={{
                             display: "flex",
                             flexDirection: "column",

                         }}>
                             {!item.is_competitor || this.props.readonly ? <Button mode="outline" size="m"
                                 >{num_collections}</Button>
                                 :

                                 <KBInput value={item.qnt * 1?? ''}
                                          style={{
                                              width: '62px',
                                              padding: '7px',
                                              justifyContent: 'center',
                                              fontSize: '17px'
                                          }}

                                          onChange={(val) => this.setCompetitorValue(item, val)}/>
                             }
                         </div>
                         }

                         bottom={<div>
                             {groups.map(group => <div key={group.key} style={{marginBottom: '6px'}}>
                                 {group.title ? <div style={{
                                     fontSize: '12px',
                                     fontWeight: 600,
                                     margin: '2px 0 2px 5px',
                                     color: '#2f6f62',
                                 }}>{group.title}</div> : null}
                                 <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                     {group.items.map(collection =>
                                         <span key={collection.id} className="summary-chip">{collection.title}</span>)}
                                 </div>
                             </div>)}
                         </div>}
                         style={{backgroundColor: item.is_competitor ? 'rgba(88,117,183,0.4)' : 'inherit'}}
        >
            {item.title} {item.type_id > 0 ? <b>{this.types[item.type_id]}</b> : <b>Тип не указан</b>}
        </RichCell>
    }
    receiveMessage = (event) => {

        if (event.data.type === 'selectListObject') {
            const {current_item} = this.state
            if (event.data.item) {
                const {item} = event.data
                if (!current_item.collections) {
                    current_item.collections = {}
                }

                if (item.checked) {
                    current_item.collections[item.id] = item
                } else if (current_item.collections[item.id]) {
                    delete current_item.collections[item.id]
                }


                const {current_document} = this.props

                const values = current_document.items

                console.log(current_item, values)
                let current_index = -1
                Object.keys(values).map((id) => {
                    if (current_index !== -1) return
                    if (values[id].id == current_item.id) {
                        current_index = id
                    }
                })
                if (current_index === -1) return

                values[current_index] = current_item

                current_document.items = values

                window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})

            }
        }
    }

    setCompetitorValue = (current_item, val) => {
        if (this.interval) {
            clearInterval(this.interval)
        }

        this.interval = setInterval(() => {
            clearInterval(this.interval)

            const {current_document} = this.props

            const values = current_document.items
            let current_index = -1
            Object.keys(values).map((id) => {
                if (current_index !== -1) return
                if (values[id].id == current_item.id) {
                    current_index = id
                }
            })
            if (current_index === -1) return


            current_item.qnt = val

            values[current_index] = current_item

            current_document.items = values

            window.postMessage({type: 'setCurrentSalePointMonitoring', value: current_document})
        }, 770)
    }

    render() {

        return (<SplitLayout modal={
            <StandCollectionsSelectList
                activeModal={this.state.activeModal}
                modalBack={this.modalBack}
                current_item={this.state.current_item}
                params={{stand_id: this.state.current_item.id}}
                modal_title={`Коллекции стенда ${this.state.current_item.title}`}
            />}>
            <SplitCol>
                <List>
                    {Object.keys(this.props.list).map((key) => {
                        const item = this.props.list[key]


                        return this.renderRow(item)
                    })}

                </List>
            </SplitCol>
        </SplitLayout>)
    }

}

export default SummaryListSalePoint